import script from "./RolePermissionsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RolePermissionsForm.vue?vue&type=script&setup=true&lang=js"

import "./RolePermissionsForm.vue?vue&type=style&index=0&id=b11cdfd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b11cdfd4"]])

export default __exports__